<template>
    <div class="wrapper success_base jianzhan_base" style="padding-top: 25px">
        <jzcommon :title="title"></jzcommon>
    </div>
</template>

<script>
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import lib_activity from "@/libs/lib_activity";
    import _wx from "@/common/_wx";
    import lib_city from "@/libs/lib_city";
    import Toast from "vant/lib/toast";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import _monitor from "@/monitor/_monitor";
    import cache_url from "@/cache/cache_url";
    import lib_success from "@/libs/lib_success";
    import _geturl from "@/utils/_geturl";
    import jzpolicy from "@/components/jzpolicy";
    import _copyUrl from "@/common/_copyUrl";
    import jzcommon from "@/components/jzcommon";

    let action_form = {
        name: '', //姓名
        phone: '', //电话
        city: '', //城市
    }

    export default {
        name: "showshare",
        components: {jzcommon},
        data() {
            return {
                title: '', //主题
            }
        },
        mounted() {
            this.title = '领取门票'
            document.title = '领取门票'
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    @import "../../assets/style/autoshow/form.less";
    @import "../../assets/style/secondary/jianzhan";
    // form
    @import "../../assets/style/common/successful.less"; // 成功
    /deep/ .el-divider--horizontal {
        margin: 10px 0;
    }
</style>